import React from "react";
import CardImg from "./../Assets/Menu/MenuCArd4.png";
import Footer from "../Components/Footer/Footer";
import ProductCard from "../Components/ProductCard/ProductCard";
import { Box } from "@mui/material";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function GrilledPork() {
  useMetaTracking("ViewContent", {
    content_name: "Grilled Pork",
    content_category: "Regular Menu",
    content_ids: ["grilled_pork"],
    content_type: "bánh mì",
    value: 8.0,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Grilled Pork | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Tender grilled pork, smoky and caramelized just right, packed inside a crusty baguette with fresh herbs and pickled veggies. One bite, and you’ll get why it’s a fan favorite."
        />
        <meta property="og:title" content="Grilled Pork | Đông Hưng Viên Bakery" />
        <meta
          property="og:description"
          content="Tender grilled pork, smoky and caramelized just right, packed inside a crusty baguette with fresh herbs and pickled veggies. One bite, and you’ll get why it’s a fan favorite."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <ProductCard
          cardImg={CardImg}
          titleHead="Grilled Pork"
          titleSubHead="$8.00 each"
          detailBodyBr="Tender grilled pork, smoky and caramelized just right, packed inside a crusty baguette with fresh herbs and pickled veggies. One bite, and you’ll get why it’s a fan favorite."
          detailBody3="Contains: wheat, soy, egg, fish"
          ProductCardBtn="View Full Regular Menu"
          btnLink="/regular-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default GrilledPork;